module.exports = __webpack_public_path__ + "files/52357f0e805be9eb462d196875f8c19e.svg";